import styled from "styled-components";
// 가운데 주제(title)와 세 갈래 항목(data 3개)을 연결해 보여준다
const HexagonalFour = ({ title, data }) => {
  return (
    <Div>
      <div className="center">{title}</div>
      <ul>
        {data?.map((x, idx) => (
          <li key={idx}>
            <strong>{x.title}</strong>
            <p>{x.text}</p>
          </li>
        ))}
      </ul>
    </Div>
  );
};
export default HexagonalFour;
const Div = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  & > .center {
    position: relative;
    padding: 0.9rem 2rem;
    border-radius: 999px;
    background-color: ${({ theme }) => theme.colors.dark};
    color: white;
    font-size: 1.15rem;
    font-weight: 700;
    margin-bottom: 2.5rem;
    &:after {
      content: "";
      position: absolute;
      left: 50%;
      top: 100%;
      width: 1px;
      height: 2.5rem;
      background-color: ${({ theme }) => theme.colors.light};
    }
  }
  & > ul {
    width: 100%;
    list-style: none;
    margin: 0;
    padding: 1.5rem 0 0;
    border-top: 1px solid ${({ theme }) => theme.colors.light};
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(16rem, 1fr));
    gap: 1rem;
    & > li {
      padding: 1.75rem 1.5rem;
      border-radius: ${({ theme }) => theme.radius};
      border: 1px solid ${({ theme }) => theme.colors.line};
      background-color: white;
      & > strong {
        display: block;
        font-size: 1.2rem;
        color: ${({ theme }) => theme.colors.dark};
        margin-bottom: 0.6rem;
      }
      & > p {
        margin: 0;
        line-height: 1.7;
        color: ${({ theme }) => theme.colors.foreground.dimmed};
      }
    }
  }
`;
